import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

const TechnologyCard = ({ 
  name, 
  tagline, 
  description, 
  image, 
  path, 
  index = 0,
  variant = 'default' 
}) => {
  const variants = {
    default: 'col-span-1',
    wide: 'col-span-1 md:col-span-2',
    tall: 'col-span-1 row-span-2',
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ 
        duration: 0.8, 
        delay: index * 0.1, 
        ease: [0.22, 1, 0.36, 1] 
      }}
      className={`${variants[variant]} group`}
      data-testid={`technology-card-${name.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <Link to={path} className="block h-full">
        <div className="relative h-full min-h-[400px] md:min-h-[450px] bg-[#FDF8F5] overflow-hidden border border-[#E5E5E5] hover:border-[#1A1A1A] transition-all duration-500">
          {/* Image Container */}
          <div className="absolute inset-0 overflow-hidden">
            <img
              src={image}
              alt={name}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/80 via-[#1A1A1A]/20 to-transparent" />
          </div>

          {/* Content */}
          <div className="absolute inset-0 p-8 md:p-10 flex flex-col justify-end">
            <span className="overline text-white/70 mb-3">{tagline}</span>
            <h3 className="heading-3 text-white mb-3">{name}</h3>
            <p className="body-text text-white/80 mb-6 max-w-md line-clamp-2">
              {description}
            </p>
            
            {/* Learn More */}
            <div className="flex items-center gap-2 group/btn">
              <span className="overline text-white group-hover/btn:text-[#F7E7CE] transition-colors">
                Learn More
              </span>
              <div className="w-8 h-8 border border-white/30 flex items-center justify-center group-hover/btn:bg-white group-hover/btn:border-white transition-all duration-300">
                <ArrowUpRight className="w-4 h-4 text-white group-hover/btn:text-[#1A1A1A] transition-colors" />
              </div>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default TechnologyCard;
